import _ from 'lodash';
import * as React from 'react';

import { ConceptSelectorWithCheckbox } from '../internalTools/index';

export interface ConceptResult {
  [uid: string]: boolean | string;
}

export interface Concept {
  displayName: string;
  uid: string;
}

export interface ConceptsData {
  data: {
    '0': Concept[];
  };
}

export interface Response {
  optimal: boolean | string;
}

export interface ConceptResultsProps {
  conceptResults: ConceptResult;
  concepts: ConceptsData;
  deleteConceptResult: (uid: string) => void;
  fillInTheBlank?: boolean;
  handleConceptChange: (uid: string) => void;
  mode?: string;
  response: Response;
  toggleCheckboxCorrect: (uid: string) => void;
}

export const ConceptResults: React.FC<ConceptResultsProps> = ({
  conceptResults,
  concepts,
  deleteConceptResult,
  fillInTheBlank,
  handleConceptChange,
  mode,
  response,
  toggleCheckboxCorrect,
}) => {
  const renderConceptResults = () => {
    const conceptResultsCopy = Object.assign({}, conceptResults);
    let components;

    if (conceptResultsCopy) {
      if (mode === 'Editing') {
        const conceptResultsPlus = Object.assign(conceptResultsCopy, { null: response.optimal });
        components = Object.keys(conceptResultsPlus).map((uid) => {
          const concept = _.find(concepts.data['0'], { uid });
          return (
            <ConceptSelectorWithCheckbox
              checked={uid === 'null' ? false : conceptResultsCopy[uid]}
              currentConceptUID={uid}
              deleteConceptResult={() => deleteConceptResult(uid)}
              fillInTheBlank={fillInTheBlank}
              handleSelectorChange={handleConceptChange}
              key={uid}
              onCheckboxChange={() => toggleCheckboxCorrect(uid)}
              selectorDisabled={uid === 'null' || uid === null ? false : true}
            />
          );
        });
      } else {
        components = Object.keys(conceptResultsCopy).map((uid) => {
          const concept = _.find(concepts.data['0'], { uid });
          if (concept) {
            // hacky fix for the problem where concept result uids are being returned with string value 'false' rather than false
            return (
              <li key={uid}>
                {concept.displayName}{' '}
                {conceptResultsCopy[uid] && conceptResultsCopy[uid] !== 'false' ? (
                  <span className="tag is-small is-success">Correct</span>
                ) : (
                  <span className="tag is-small is-danger">Incorrect</span>
                )}
                {'\t'}
              </li>
            );
          }
        });
      }
      return components;
    }
  };

  const content = renderConceptResults();
  return mode === 'Editing' ? <div>{content}</div> : <ul>{content}</ul>;
};
